import React from 'react';
import Seo from '../components/Seo';
import { Link } from 'react-router-dom';
import { Flame, ArrowRight } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';
import { FAQS, BRAND } from '../mock/mock';
import Reveal from '../components/Reveal';

const FAQs = () => {
  const faqLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: FAQS.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };
  return (
    <div className="bg-fire-ink">
      <Seo title="FAQs" path="/faqs" description="Answers to common questions about After the Fire™, the ATF Experience and Fireside Clarity Calls with Dr. Gee." jsonLd={faqLd} />
      <section className="pt-32 pb-14 text-center relative overflow-hidden">
        {/* Background photo of Dr. Gee */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: 'url(/brand/drgee-ballpit.jpg)', backgroundPosition: 'center 30%' }}
          data-testid="faqs-hero-bg"
        />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, rgba(23,17,13,0.84) 0%, rgba(23,17,13,0.74) 50%, rgba(23,17,13,0.96) 100%)' }} />
        <div className="max-w-3xl mx-auto px-6 relative">
          <Flame className="w-8 h-8 text-fire-gold mx-auto mb-5 animate-flicker" strokeWidth={1.4} />
          <span className="font-marcellus tracking-[0.25em] text-fire-gold text-xs">FREQUENTLY ASKED QUESTIONS</span>
          <h1 className="font-display text-4xl md:text-6xl text-fire-cream mt-4">Answers by the Fire</h1>
          <p className="text-fire-cream/70 font-body mt-4">Everything you may be wondering about After the Fire™, the Experience and Fireside Clarity Calls.</p>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-[860px] mx-auto px-5 lg:px-8">
          <Reveal>
            <Accordion type="single" collapsible className="space-y-4">
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="card-dark rounded-2xl px-6 border-none overflow-hidden">
                  <AccordionTrigger className="text-left font-display text-lg text-fire-cream hover:no-underline hover:text-fire-goldlight py-5">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-fire-cream/65 font-body text-sm leading-relaxed pb-5">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>

          {/* Declaration */}
          <Reveal delay={120} className="mt-14">
            <div className="rounded-2xl p-9 text-center bg-gradient-to-br from-fire-maroon to-fire-maroondark border border-fire-gold/30">
              <span className="font-marcellus tracking-[0.25em] text-fire-gold text-xs">THE AFTER THE FIRE™ DECLARATION</span>
              <p className="font-cormorant text-2xl md:text-3xl text-fire-cream italic mt-5 leading-relaxed">
                “{BRAND.declaration}”
              </p>
              <p className="text-fire-cream/70 font-body text-sm mt-5 max-w-lg mx-auto">
                You may have scars, but scars are evidence that the wound closed. Don’t build your identity around what burned. Build your life around what survived.
              </p>
              <div className="flex flex-wrap gap-4 justify-center mt-8">
                <Link to="/contact" className="btn-gold rounded-full px-7 py-3.5 font-semibold inline-flex items-center gap-2 text-sm">
                  Contact Dr. Gee <ArrowRight className="w-4 h-4" />
                </Link>
                <Link to="/fireside" className="btn-outline-gold rounded-full px-7 py-3.5 font-semibold text-sm">
                  Book a Fireside Call
                </Link>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default FAQs;
